(function () {
  'use strict';

  function syncBannerHeight(collapsed) {
    if (collapsed) document.documentElement.style.setProperty('--banner-height', '0px');
    else document.documentElement.style.removeProperty('--banner-height');
  }

  function initHeader(header) {
    if (!header || header.dataset.headerReady === 'true') return;
    header.dataset.headerReady = 'true';
    const menuButton = header.querySelector('[data-menu-toggle]');
    const menu = header.querySelector('[data-menu]');
    const close = header.querySelector('[data-announcement-close]');
    const hasAnnouncement = header.dataset.hasAnnouncement !== 'false' && Boolean(close);
    let dismissed = false;

    try { dismissed = sessionStorage.getItem('frnk-announcement') === 'dismissed'; } catch (error) {}
    header.classList.toggle('is-dismissed', dismissed);
    syncBannerHeight(!hasAnnouncement || dismissed);

    if (menuButton && menu) {
      menuButton.addEventListener('click', function () {
        const open = menuButton.getAttribute('aria-expanded') === 'true';
        menuButton.setAttribute('aria-expanded', String(!open));
        menu.classList.toggle('is-open', !open);
      });
    }

    if (close) {
      close.addEventListener('click', function () {
        header.classList.add('is-dismissed');
        syncBannerHeight(true);
        try { sessionStorage.setItem('frnk-announcement', 'dismissed'); } catch (error) {}
      });
    }
  }

  function initProduct(section) {
    if (!section || section.dataset.productReady === 'true') return;
    section.dataset.productReady = 'true';
    const select = section.querySelector('select[name="id"]');
    const button = section.querySelector('[data-add-button]');
    const price = section.querySelector('[data-product-price] .price');
    if (!select || !button) return;

    select.addEventListener('change', function () {
      const option = select.options[select.selectedIndex];
      const available = option && option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  }

  function respectMediaPreferences(scope) {
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection && navigator.connection.saveData;
    if (!reducedMotion && !saveData) return;
    (scope || document).querySelectorAll('.hero-fold video').forEach(function (video) {
      video.pause();
      video.removeAttribute('autoplay');
      video.preload = 'none';
    });
  }

  function normalizedText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase();
  }

  function enhanceSignup(embed) {
    if (!embed) return;
    const duplicateCopy = [embed.dataset.signupHeading, embed.dataset.signupBody]
      .map(normalizedText)
      .filter(Boolean);

    embed.querySelectorAll('h1, h2, h3, h4, h5, h6, p').forEach(function (element) {
      if (element.closest('[role="alert"], [role="status"], [aria-live]:not(form), [data-signup-preserve]')) return;
      if (duplicateCopy.includes(normalizedText(element.textContent))) {
        const component = element.closest('[data-testid="form-component"]');
        const hasFunctionalContent = component && component.querySelector('input, button, select, textarea, label, [role="alert"], [role="status"], [aria-live], [data-signup-preserve]');
        const componentCopy = component && Array.from(component.querySelectorAll('h1, h2, h3, h4, h5, h6, p'))
          .map(function (copyElement) { return normalizedText(copyElement.textContent); })
          .filter(Boolean);
        const componentIsDuplicateCopy = componentCopy && componentCopy.length > 0 && componentCopy.every(function (copy) {
          return duplicateCopy.includes(copy);
        });
        const duplicateTarget = component && !hasFunctionalContent && componentIsDuplicateCopy ? component : element;
        duplicateTarget.hidden = true;
        duplicateTarget.dataset.signupDuplicate = 'true';
      }
    });

    embed.querySelectorAll('form').forEach(function (form) {
      form.classList.add('signup-klaviyo-form');
      if (form.parentElement) form.parentElement.classList.add('signup-klaviyo-shell');
      const inner = form.firstElementChild;
      if (!inner || !inner.matches('div')) return;
      inner.classList.add('signup-form-inner');
      form.querySelectorAll('input[type="email"]').forEach(function (input) {
        const emailRow = input.closest('[data-testid="form-row"]');
        const action = form.querySelector('button.klaviyo-form-button[type="button"][data-action-id]');
        const actionRow = action && action.closest('[data-testid="form-row"]');
        if (!emailRow || !actionRow || emailRow === actionRow || emailRow.parentElement !== inner || actionRow.parentElement !== inner) return;
        inner.classList.add('signup-control-grid');
        emailRow.classList.add('signup-email-row');
        actionRow.classList.add('signup-action-row');
        action.classList.add('signup-submit-control');
      });
    });
  }

  function setPreviewSignupState(embed) {
    if (!embed.hasAttribute('data-signup-preview')) return;
    const state = new URLSearchParams(window.location.search).get('signup-state') || 'initial';
    const input = embed.querySelector('input[type="email"]');
    const button = embed.querySelector('.signup-submit-control');
    embed.querySelectorAll('[data-preview-state]').forEach(function (message) {
      message.hidden = message.dataset.previewState !== state;
    });
    if (input) {
      input.disabled = false;
      input.setAttribute('aria-invalid', String(state === 'error'));
      if (state === 'error') input.setAttribute('aria-describedby', 'PreviewEmailError');
      else input.removeAttribute('aria-describedby');
    }
    if (button) {
      button.disabled = state === 'loading';
      button.setAttribute('aria-busy', String(state === 'loading'));
      button.textContent = state === 'loading' ? 'Submitting…' : 'Subscribe';
    }
  }

  function initSignup(embed) {
    if (!embed || embed.dataset.signupReady === 'true') return;
    embed.dataset.signupReady = 'true';
    enhanceSignup(embed);
    setPreviewSignupState(embed);
    if (!window.MutationObserver) return;
    const observer = new MutationObserver(function () { enhanceSignup(embed); });
    observer.observe(embed, { childList: true, subtree: true });
  }

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-site-header]').forEach(initHeader);
    root.querySelectorAll('[data-product-section]').forEach(initProduct);
    root.querySelectorAll('[data-signup-embed]').forEach(initSignup);
    if (window.FRNKTurn) window.FRNKTurn.initAll(root);
    respectMediaPreferences(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
